var map = {
	"./AERO.svg": 90036,
	"./ALB.svg": 82793,
	"./Auction.svg": 72099,
	"./B2B.svg": 1615,
	"./BALD.svg": 89891,
	"./BASED.svg": 51468,
	"./BSWAP.svg": 18321,
	"./DIP.svg": 18120,
	"./DOGE.svg": 19332,
	"./DOV.svg": 43112,
	"./EUR.svg": 52490,
	"./Ehter.svg": 23958,
	"./GROK.svg": 53799,
	"./JPY.svg": 51754,
	"./KRAV.svg": 39715,
	"./MAG.svg": 29849,
	"./PIKA.svg": 87845,
	"./RLB.svg": 21299,
	"./SHIB.svg": 77513,
	"./SURE.svg": 662,
	"./TOSHI.svg": 87696,
	"./Tehter.svg": 13022,
	"./UNIBOT.svg": 84925,
	"./USDCoin.svg": 99915,
	"./YOU.svg": 96122,
	"./asset_BNB.svg": 78305,
	"./bitcoin.svg": 2332,
	"./coinbase.svg": 78155,
	"./dai.svg": 86025,
	"./default_token.svg": 55172,
	"./karv_icon.svg": 62269,
	"./ndaq_icon.svg": 72532,
	"./pogai.svg": 46067
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96085;